<!-- Path: /external/cannot-link-external -->
<template>
  <div class="page">
    <Splash />
    <div class="center">
      <FormContainer header="Something Went Wrong">
        <!-- use slot -->
        <template #form-content>
          <div class="form-header">
            <div>
              <img
                srcset="@/assets/images/failed-error.png 1x, @/assets/images/failed-error-2x.png 2x"
                src="@/assets/images/failed-error.png"
                title="Deposits failed"
              />
            </div>
            Cannot Link External Account
          </div>

          <div class="v-spacer-20" />
          <div class="failed-msg">
            We were unable to link your external bank account. Please confirm the information you
            entered is correct, then try again.
          </div>
          <div class="v-spacer-20" />
          <div class="button-container">
            <button class="back-btn" @click="goBack">TRY AGAIN</button>
          </div>
          <div style="text-align: center; margin-top: 50px">
            Need help? Call us at (808) 844-4545 or toll-free at (800) 894-5600.
          </div>
        </template>
      </FormContainer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import FormContainer from "@/components/FormContainer.vue"
import Splash from "@/components/Splash.vue"
import jquery from "jquery"

export default {
  name: "ExternalLinkUnsuccessful",
  components: {
    FormContainer,
    Splash,
  },
  data() {
    return {
      missingSelectedAccount: false,
      processing: false,
      next: false,
      account: "",
    }
  },
  methods: {
    ...mapActions("fundnow", ["setProductName", "setPriorityChecking", "setCDProduct"]),

    goBack() {
      this.$router.push("/external/new")
    },
  },
  computed: {
    ...mapGetters("fundnow", ["getProductName", "getPriorityChecking", "getCDProduct"]),
    product_name: {
      get() {
        return this.getProductName
      },
      set(v) {
        this.setProductName(v)
      },
    },
    priority_checking: {
      get() {
        return this.getPriorityChecking
      },
      set(v) {
        this.setPriorityChecking(v)
      },
    },
    cd_product: {
      get() {
        return this.getCDProduct
      },
      set(v) {
        this.setCDProduct(v)
      },
    },
  },
  mounted() {
    jquery("html, body").animate({ scrollTop: 0 })
  },
}
</script>
<style scoped lang="scss">
@import "./src/scss/_variables.scss";
@import "./src/scss/_mixins.scss";

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}
.error {
  color: $red;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 15px;
  font-weight: 450;
  line-height: 23px;
  img {
    width: 15px;
    height: 15px;
  }
}
.back-btn {
  width: 175px;
  height: 40px;
  border-radius: 999px;
  padding: 4px 24px;
  border: solid 1px $yellowLight;
  background-color: $yellowLight;
  cursor: pointer;
  &:hover,
  :active {
    background-color: $yellowHover;
  }
}
.small-checkmark {
  width: 36px;
  height: 36px;
  vertical-align: middle;
  margin-left: 5px;
}
.deposits-sent-info {
  margin: 10px 0;
}
.failed-msg {
  font-size: 22px;
  font-weight: 450;
  line-height: 36px;
  letter-spacing: -0.011em;
  text-align: center;
}
.close-container {
  text-align: center;
  margin-top: 60px;
}
</style>
